import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} — PhotoFeeler AI` : 'PhotoFeeler AI — AI Photo Rating';
    return () => { document.title = prev; };
  }, [title]);
}
